// Where the live sheet's dice bar posts. The island registers a resolver that reads its current snapshot at call time,
// since who may post follows the sheet (an owner change or a campaign change) and a copied value would lag behind it.
// Null until the island registers one, and again once it leaves.
let resolver: (() => string | null) | null = null;

export const sheetRollUrl = () => resolver?.() ?? null;

export function setSheetRollUrl(value: (() => string | null) | null) {
	resolver = value;
}
